import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as me from '../../../me'
import * as routeBound from '../../../route-bound'
import * as surveyAdmins from '../survey-admins'
import type { TypeParams } from '../types'

import { Api } from './api.service'

/** Standard users collection, listing their assignments to organizations. */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    const meFeature = ngCore.inject(me.Feature)
    const surveyAdminsEc = ngCore.inject(surveyAdmins.Collection)

    // Only platform admins, tenant admins, and survey admins remove standard
    // user assignments. Computed once here (rather than inside rowConfig, which
    // runs once per row) so it isn't rebuilt on every row of every render.
    const canManageSg = ngCore.computed(
      (
        canManageUsers = meFeature.contexts.selectors.currentUserCanManageUsers.asSignal(),
        currentUserId = meFeature.selectors.currentUserId.asSignal(),
        surveyAdminUserIds = new Set(
          surveyAdminsEc.plugins.currentListPlugin.feature.selectors.entities
            .asSignal()
            .map(({ userId }) => userId),
        ),
      ) =>
        canManageUsers ||
        (!!currentUserId && surveyAdminUserIds.has(currentUserId)),
    )

    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: standardUser => standardUser.id,
      name: ec.Name.Predefined.SpaceStandardUser,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory<TypeParams>(collection => ({
            rowConfig: ({ entity: { id } }) => ({
              iconsConfigs: canManageSg()
                ? [
                    {
                      class: 'atn-icon atn-trash atn-red',
                      onClick: () =>
                        collection.plugins.editingPlugin.feature.actions.markForDeletion
                          .from(`Table.Row-${id}.Icons.Trash.Clicked`)
                          .dispatch({ id }),
                    },
                  ]
                : [],
            }),
          })),
        ],
      },
    })
  }
}
